












































































import { Component, Prop, Vue, Emit } from 'vue-property-decorator'
import { TileType } from '@/data/enums'
import Tile from '@/store/models/Tile'
import RatingIcon from '@/components/ui/RatingIcon.vue'

@Component({
  components: {
    RatingIcon
  }
})
export default class ImageTile extends Vue {
  private loaded: boolean = false
  private publicPath: string = process.env.BASE_URL
  private showValueSelector: boolean = false

  @Prop() private index!: number
  @Prop() private tile!: Tile
  @Prop({ default: TileType.Default }) private type!: TileType

  private get color () {
    if (this.value === 0) {
      return 'red'
    } else if (this.value === 1) {
      return 'orange'
    } else {
      return 'green'
    }
  }

  private get isDisabled () {
    return !this.tile.enabled
  }

  private get isSelected () {
    return this.tile.selected
  }

  private get title () {
    return this.tile.title
  }

  private get value () {
    return this.tile.value
  }

  @Emit('selectionChange')
  public emitChange (tile: Tile) {
    // Emit selection change
  }

  private onClick () {
    if (!this.isDisabled) {
      this.tile.selected = !this.tile.selected
      this.emitChange(this.tile)
    }
  }

  private onLoaded () {
    this.loaded = true
  }

  private selectValue (value: number) {
    this.tile.value = value
    this.emitChange(this.tile)
  }

  private mounted () {
    if (this.$props.type !== TileType.Default) {
      this.showValueSelector = true
    }
    if (!this.tile.src) {
      this.tile.src = ''
    }
    if (this.value === undefined) {
      this.tile.value = 1
    }
  }
}
